import { useEffect, useState } from "react"

import { Flex, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import Button from "../../../Components/Button"
import EmptyComponent from "../../../Components/Empty"
import Modal from "../../../Components/Modal"
import { RoutesPaths } from "../../../constants/user-routes"
import Icon from "../../../Icon"

const { Text } = Typography

// Explainer video embed URL. Empty until the real one is provided; the modal
// shows a "coming soon" placeholder rather than an embarrassing default video.
const LEARN_MORE_VIDEO_URL = ""

// Shown on an empty /recover/all before activation. Recover is activated by
// finishing the Configure wizard (Finish & save, which is disabled until a payment
// gateway is connected), so the primary CTA starts that wizard rather than flipping
// activation directly here.
const RecoverEmptyState = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [videoOpen, setVideoOpen] = useState(false)

  useEffect(() => {
    document.title = "Recover - Chargeback"
  }, [])

  return (
    <div className="recover-empty-state">
      <EmptyComponent type="activate_recover">
        <Space size={12} style={{ marginTop: 16 }}>
          <Button
            type="primary"
            text={t("Set up Recover")}
            onClick={() => navigate(RoutesPaths.recover.configure_section("integrations"))}
          />
          <Button type="default" text={t("Learn more")} onClick={() => setVideoOpen(true)} />
        </Space>
      </EmptyComponent>

      <Modal
        visible={videoOpen}
        handleClose={() => setVideoOpen(false)}
        width={720}
        centered
        destroyOnClose
        title={t("How Recover works")}
      >
        {LEARN_MORE_VIDEO_URL ? (
          <div style={{ position: "relative", paddingTop: "56.25%" }}>
            <iframe
              title={t("How Recover works")}
              src={LEARN_MORE_VIDEO_URL}
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <Flex
            vertical
            align="center"
            justify="center"
            gap={8}
            style={{ minHeight: 200, textAlign: "center" }}
          >
            <Icon type="play" style={{ fontSize: 20 }} />
            <Text type="secondary">{t("The walkthrough video is coming soon.")}</Text>
          </Flex>
        )}
      </Modal>
    </div>
  )
}

export default RecoverEmptyState
